module.exports = __webpack_public_path__ + "img/5.3559bfb5.png";